import { IInterventionCount } from 'models/Intervention';

import { ReduxStore } from 'store/types';

function getAllCount(state: ReduxStore): IInterventionCount {
  return state.intervention.getAll.config.count;
}

export default getAllCount;
